/**
 * DettoSì — the theme's only script.
 *
 * Enhances native navigation and reveals sections on scroll.
 * Product and cart submissions remain native forms.
 */
(function () {
  'use strict';

  var header = document.querySelector('[data-site-header]');
  if (header) {
    var menus = header.querySelectorAll('[data-site-menu]');
    var updateHeight = function () {
      document.documentElement.style.setProperty('--site-header-height', header.offsetHeight + 'px');
    };
    updateHeight();
    if ('ResizeObserver' in window) new ResizeObserver(updateHeight).observe(header);
    menus.forEach(function (menu) {
      var summary = menu.querySelector('summary');
      summary.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', String(menu.open));
      });
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.open) {
          menu.open = false;
          summary.focus();
          event.preventDefault();
        }
      });
      menu.addEventListener('click', function (event) {
        var link = event.target.closest('a');
        if (!link) return;
        menu.open = false;
        var url = new URL(link.href);
        var target = url.pathname === location.pathname && url.hash ? document.getElementById(url.hash.slice(1)) : null;
        if (target) {
          target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        } else summary.focus({ preventScroll: true });
      });
      document.addEventListener('click', function (event) {
        if (!menu.contains(event.target)) menu.open = false;
      });
      menu.addEventListener('focusout', function () {
        setTimeout(function () { if (!menu.contains(document.activeElement)) menu.open = false; }, 0);
      });
    });
    window.matchMedia('(min-width: 75rem)').addEventListener('change', function () {
      menus.forEach(function (menu) { menu.open = false; });
    });
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll('.reveal');
  if (!targets.length) return;

  // Arming happens here so that a browser without JavaScript never hides
  // anything.
  document.documentElement.setAttribute('data-reveal', 'on');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
  );

  targets.forEach(function (target) {
    observer.observe(target);
  });
})();
